import React, { useEffect, useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import { BiArrowBack } from 'react-icons/bi'
import { AiOutlineWarning } from 'react-icons/ai'
import { RxCross2 } from 'react-icons/rx'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { db } from "../firebase-config";
import { collection, addDoc, setDoc, doc} from "firebase/firestore"; 
import "../styles/components/loader.css"
import { Link, Navigate } from 'react-router-dom';
import Financeurs from './Financeurs';
import {v4 as uuidv4} from 'uuid' 
import { IoHelpCircleOutline } from "react-icons/io5";
import { FaAsterisk } from "react-icons/fa";

export function Form() {


      const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
            mode: 'onChange',
            defaultValues: "",
      })

      const [submitSuccess, setSubmitSuccess] = useState(false)

      const [newUsermail, setNewUsermail] = useState()

      const [infoBoxState, setInfoBoxState] = useState(false)
      
      const [payInfoBoxState, setPayInfoBoxState] = useState(false)

      const [validation, setValidation] = useState("")
      
      const [employeeNumber, setEmployeeNumber] = useState(" ")
      
      const formRef = useRef()

    
      
      const [showForm, setShowForm] = useState(false);

      
  
     
      const onSubmit = async data  => {

            var id = uuidv4();
            var acceptAnsw = "Non";     
            var fonction = "Non renseigné";
            var tel = "Non renseigné";
            var village = "Non renseigné";
            var participation = "Non";
            var organisation = "Non renseigné";
       
          if(data.fonction) {
            fonction = data.fonction
          } 
                    
          if(data.tel) {
            tel = data.tel
          } 

          if(data.accept) {
            acceptAnsw = data.accept
          } 

          if(data.village) {
            village = data.village
          } 

          if(data.participate) {
            participation = data.participate
          } 

          if(data.organisation) {
            organisation = data.organisation
          } 

 
                    

        try {
          setTimeout(() => {
            const preSubInfo = {
              ID: id, 
              ORGANISME: data.organisme,
              NOM: data.name,
              PRENOM: data.firstName,
              FONCTION: fonction,
              TELEPHONE: tel,
              MAIL: data.email,
              PARTICIPATION: participation,
              ORGANISATION: organisation,
              LINK: data.link,
              AUTORISATION : acceptAnsw,
              CGV: data.cgv,
              
            }
            console.log(preSubInfo)
            console.log(data)

            if(employeeNumber === "-10") {
              const ref = collection(db, "inscriptions", 'exposants', '2024', 'type', 'payant', 'tarifs', '300_euros');
              const docRef = setDoc(doc(ref, id), preSubInfo)
            } else {
              const ref = collection(db, "inscriptions", 'exposants', '2024', 'type', 'payant', 'tarifs', '500_euros');
              const docRef = setDoc(doc(ref, id), preSubInfo)
            }
           
            setSubmitSuccess(true)
            setValidation("Merci, Vos réponses ont bien été enregistrées. Vous serez recontactés prochainement par téléphone pour définir les modalités de votre participation")
          }, 1000)

          }
                  catch(err) {
                  console.log(err);
                  setSubmitSuccess(false)
                  setValidation("Une erreur s'est produite, veuillez réessayer ultérieurement")
                
              }
          
              formRef.current.reset();

              
    }
    

            return (

              <div> 

                    {isSubmitting && (
                      <div className="loader"></div>
                    )} 
      
                    
            
                        <form ref={formRef} id="sign-in" onSubmit={handleSubmit(onSubmit)}>
                          
                         
                        {validation !== "" ? 
                    
                    <div className={submitSuccess === true ? "validation Success" : "validation Error"} >
                      {validation}
                    </div>
                    
                    : 

                           

                        <>        
                       <div className="rowRP">
                        <input type='text' id="structure" name="organisme" placeholder="Organisme ou entreprise" {...register('organisme', {required: true})}></input>
                        <label htmlFor="asterisk" className='asteriskLabel' id='asteriskOne'><span className="asterisk"><FaAsterisk /></span></label>
                        {errors.organisme?.type === "required" && (
                            <small>Veuillez renseigner l'organisme que vous représentez</small>
                          )}
                        </div>
                        <div className="organisation">
                          <h4>Organisation professionelle avec laquelle vous participez</h4>
                          {errors.organisation?.type === "required" && (
                            <small>Veuillez choisir une organisation</small>
                          )}
                          <div className="chx">
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="AFT" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">AFT</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="AFTRAL" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">AFTRAL</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="FDSEA (ANEFA90)" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">FDSEA (ANEFA90)</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="ARIQ BTP" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">ARIQ BTP</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="FDBTP" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">FDBTP</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="FNTR FC" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">FNTR FC</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="FRTP" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">FRTP</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="GEIQ BFC" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">GEIQ BFC</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="MEDEF" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">MEDEF</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="UIMM" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">UIMM</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="UMIH" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">UMIH</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="VALLEE DE L'ENERGIE" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">Vallée de l'énergie</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="LABEL EMPL'ITUDE" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">Label Empl'itude</label>
                            </div>
                            <div className="row">
                             <input {...register('organisation', {required: true})} value="LES ENTREPRISES S'ENGAGENT" name="organisation" type='checkbox' id="organisation"></input>
                             <label htmlFor="organisation">Les entreprises s'engagent</label>
                            </div>
                          </div>
                        </div>
                      
                    {/* <div className="grid_form"> */}

                        <div className="represente_par">
                          <h4>Représenté par :</h4>
                          <div className="rowRP">
                            <input type='text' id="nom" name="name" placeholder="Nom" {...register('name', {required: true, message: 'Veuillez entrer votre nom'})}></input>
                            <label htmlFor="asterisk" className='asteriskLabel' id='asteriskOne'><span className="asterisk"><FaAsterisk /></span></label>
                          </div>
                          {errors.name?.type === "required" && (
                            <small>Veuillez entrer votre nom</small>
                          )}
                          <div className="rowRP">
                            <input type='text' id="prenom" name="firstName" placeholder="Prénom" {...register('firstName', {required: true, message: 'Veuillez entrer votre prénom'})}></input>
                            <label htmlFor="asterisk" className='asteriskLabel' id='asteriskTwo'><span className="asterisk"><FaAsterisk /></span></label>
                          </div>
                          {errors.firstName?.type === "required" && (
                            <small>Veuillez entrer votre prénom</small>
                          )}
                          <div className="rowRP">
                              <input type='text' id="fonction" name="fonction" placeholder="Fonction" {...register('fonction')}></input>
                          </div>
                          <div className="rowRP">
                                <input type='tel' id="tel" placeholder="Téléphone" name="tel" {...register('tel')}></input>
                          </div>
                          <div className="rowRP">
                                <input type='mail' id="email" name="email" placeholder="Mail" {...register('email', {required: true, validate: {
                                matchPattern: (v) =>
                                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
                                  "Veuillez entrer une adresse mail valide",
                              },} )}></input>
                                <label htmlFor="asterisk" className='asteriskLabel' id='asteriskThree'><span className="asterisk"><FaAsterisk /></span></label>
                          </div>
                          {errors.email?.type === "required" && (
                            <small>Veuillez entrer votre adresse mail</small>
                          )}
                          {errors.email?.message && (
                            <small>{errors.email.message}</small>
                          )}
                          <div className="rowRP">
                                <input type="text" name="link" id="" defaultValue="" placeholder="Site web" {...register('link')}/>
                          </div>
                        </div>

                        <div className={employeeNumber !== " " ? "hide" :"choices"}>
                           <div className="choice" onClick={() => setEmployeeNumber('-10')}>Moins de 10 salariés</div>
                           <div className="choice" onClick={() => setEmployeeNumber('+10')}>Plus de 10 salariés</div>
                        </div>
                
                       {employeeNumber === "-10" ? 
                       
                      
                      
                       <div className='acceptCGV'>
                           <div className='row'>
                              <input {...register('participate', {required: true})} value="Je souhaite participer à l’édition 2024 d’Agora Jobs et m’engage à réserver mon stand pour un montant de 300€" name="participate" type='checkbox' id="participateY"></input>
                              <label htmlFor="participation">Je souhaite participer à l’édition 2024 d’Agora Jobs et m’engage à réserver mon stand pour un montant de 300€ <span className='asterisk'><FaAsterisk /></span></label>
                              <div className="help" id='payInfo' onMouseEnter={() => setPayInfoBoxState(true)} onMouseLeave={() => setPayInfoBoxState(false)}>
                               <IoHelpCircleOutline />
                              </div>
                           </div>
                            {errors.participate?.type === "required" && (
                              <small>Ce champ est requis</small>
                            )}
                           <div className='row'>
                              <input {...register('cgv', {required: true})} value="J’ai pris connaissance et accepte les Conditions Générales de Vente" name="cgv" type='checkbox' id="cgv"></input>
                              <label htmlFor="participation">J’ai pris connaissance et accepte les <a href="https://firebasestorage.googleapis.com/v0/b/carrefourdesmetiers-79167.appspot.com/o/files%2FCGV-v300.pdf?alt=media&token=b17f010c-88e8-45b9-bd4a-1f85abc5ed85" target="blank">Conditions Générales de Vente</a>  <span className='asterisk'><FaAsterisk /></span></label>
                           </div>
                           {errors.cgv?.type === "required" && (
                             <small>Ce champ est requis</small>
                            )}
                           <div className="row">
                              <input {...register('accept')} type="checkbox" value="Oui" name="accept" id="accept" />
                              <label htmlFor="">Autorisez-vous la collecte de vos données par les partenaires d'Agora Jobs ? </label>
                              <div className="help" onMouseEnter={() => setInfoBoxState(true)} onMouseLeave={() => setInfoBoxState(false)}>
                               <IoHelpCircleOutline />
                              </div>
                           </div>
                          </div>    
                          
                          : employeeNumber === "+10" ? 

                          <div className='acceptCGV'>
                          <div className='row'>
                             <input {...register('participate', {required: true})} value="Je souhaite participer à l’édition 2024 d’Agora Jobs et m’engage à réserver mon stand pour un montant de 500€" name="participate" type='checkbox' id="participateY"></input>
                             <label htmlFor="participation">Je souhaite participer à l’édition 2024 d’Agora Jobs et m’engage à réserver mon stand pour un montant de 500€ <span className='asterisk'><FaAsterisk /></span></label>
                             <div className="help" id='payInfo' onMouseEnter={() => setPayInfoBoxState(true)} onMouseLeave={() => setPayInfoBoxState(false)}>
                              <IoHelpCircleOutline />
                             </div>
                          </div>
                           {errors.participate?.type === "required" && (
                             <small>Ce champ est requis</small>
                           )}
                          <div className='row'>
                             <input {...register('cgv', {required: true})} value="J’ai pris connaissance et accepte les Conditions Générales de Vente" name="cgv" type='checkbox' id="cgv"></input>
                             <label htmlFor="participation">J’ai pris connaissance et accepte les <a href="https://firebasestorage.googleapis.com/v0/b/carrefourdesmetiers-79167.appspot.com/o/files%2FCGV-v500.pdf?alt=media&token=470e93a4-3ff4-4b28-92e4-fa1e35837738" target="blank">Conditions Générales de Vente</a>  <span className='asterisk'><FaAsterisk /></span></label>
                          </div>
                          {errors.cgv?.type === "required" && (
                            <small>Ce champ est requis</small>
                           )}
                          <div className="row">
                             <input {...register('accept')} type="checkbox" value="Oui" name="accept" id="accept" />
                             <label htmlFor="">Autorisez-vous la collecte de vos données par les partenaires d'Agora Jobs ? </label>
                             <div className="help" onMouseEnter={() => setInfoBoxState(true)} onMouseLeave={() => setInfoBoxState(false)}>
                              <IoHelpCircleOutline />
                             </div>
                          </div>
                         </div>   


                           : ""

                          }

                    
                          {infoBoxState === true &&   
                          
                             <div className="acceptInfo">
                              <div className="triangle"></div>
                                <p>Vous êtes informés de la collecte de données à caractère personnel par la CCI du Territoire de Belfort et la MIFE.</p>
                                <p>Le traitement de ces données a pour finalité : </p>
                                <ul>
                                  <li>1- Informations sur les aides apportées par les partenaires </li>
                                  <li>2- Invitations et informations sur les événements organisés par la CCI90 et MIFE90 </li>
                                  <li>3- Bilan de l’action. Ce traitement est fondé juridiquement sur l’art. 6 du Règlement Général sur la Protection des Données UE/2016/679, paragraphe 1, point e) : Mission de service public Les destinataires de ces données à caractère personnel sont les collaborateurs du service de la CCI90 et la MIFE.</li>
                                </ul>
                                <p>Vous disposez d’un droit d’accès, de rectification, d’effacement ou d’opposition et de portabilité de vos données, que vous pouvez exercer à l’adresse susmentionnée ou par courriel à RGPD@bfc.cci.fr</p>
                                <p>Vous disposez également d’un droit de réclamation auprès de la CNIL , 3 place Fontenoy – TSA 80715 – 75334 PARIS CEDEX 07.</p>
                              </div>
                          

                        }
                          {payInfoBoxState === true &&   
                          
                             <div className="acceptPayInfo">
                              <div className="triangle"></div>
                                <p>L’inscription au tarif unique de 1000 € comprend :</p>
                                <ul>
                                  <li>Accès au wifi & électricité</li>
                                  <li>Repas du mercredi midi (2 pers)</li>
                                  <li>Parking gratuit</li>
                                  <li>Kit de communication exposant</li>
                                </ul>
                                <p>Les +</p>
                                <ul>
                                  <li>Des opportunités de networking</li>
                                  <li>Une visibilité maximale auprès des candidats</li>
                                  <li>Une couverture médiatique puissante (affichage, presse, radio, réseaux sociaux, …)</li>
                                </ul>
                              </div>
                          

                        }
                           
                              <button  disabled={isSubmitting}  className="btn" id="button">Envoyer</button>
                              </>
                            }

                              <div className="contact">
                                <h4>Pour plus d'informations :</h4>
                                <h3>Mathieu VIVOT</h3>
                                <h4>Commercialisation du forum AGORA JOBS</h4>
                                <h4><a href="tel:0384545456">03.84.54.54.56</a></h4>
                                <h4><a href="mailto:mvivot@belfort.cci.fr">mvivot@belfort.cci.fr</a></h4>
                              </div>
                              <Financeurs />
                        </form>
                  
                 
                 
                  </div>
          
              );
          };

export default Form;

    